<template>
  <div class="h6 bg-accent text-white px-3 py-1 rounded-full">IDNR: {{ carDetail?.internal_vehicle_no }}</div>
</template>

<script lang="ts" setup>
  import type { GraphQLCarDetail } from '~/types/graphql';

  const carDetail = inject<GraphQLCarDetail>('carDetail');
</script>

<style lang="scss" scoped></style>
